module.exports = __webpack_public_path__ + "static/media/loginsmart.1e87eff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginsmart.png
// module id = 135
// module chunks = 0